import Select from "react-select";
import { useEffect, useState, useContext, useRef } from "react";
import { petitions } from "../../../../api/calls";
import { DataContext } from "../../../../context/DataContext";
import { useForm } from "react-hook-form";
import { toast } from "sonner";
import Table from "../../../componentsTable/TableVenta";
import {
  EditableCellNumber,
  EditableCellTextarea,
} from "../../../componentsTools/EditableCell";
import { NavLink,useLocation } from "react-router-dom";
import productEmpty_light from "../../../../frontend/assets/img/spot-illustrations/35.png";
import productEmpty_dark from "../../../../frontend/assets/img/spot-illustrations/35_2.png";
import customStyles from "../../../../frontend/styles/select";
import customStyles_v2 from "../../../../frontend/styles/select_v2";
import { deleteProductDefault,deleteIGVDefault,addProduct,setValueTableDefault,calculateAmountsVenta } from "../../../../utils/helpers";

export default function EmitirCotizacion() {
  const { session, idEmpresa, user,empresa } = useContext(DataContext);

  const location = useLocation();
  const body = location.state?.body;

  const [type, setType] = useState("P");
  const [series, setSeries] = useState([]);
  const [serComprobante, setSerComprobante] = useState("");
  const [pservicio, setPservicio] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [producto, setProducto] = useState(null);
  const [cantidad, setCantidad] = useState("");
  const [precio, setPrecio] = useState("");
  const [descuento, setDescuento] = useState(body?.status ? body.venta.dsctoTasa01.toString() ?? "" : "");
  const [moneda, setMoneda] = useState([]);
  const [tpago, setTpago] = useState([]);
  const [mPago, seMpago] = useState([]);
  const [igv, setIgv] = useState(true);
  const [idVenta, setIdVenta] = useState("");

  //REFS
  const comp = useRef("");
  const monto = useRef("");
  const money = useRef("");

  const modalConfirmacion = useRef(null);
  const modalConfiguracion = useRef(null);
  const modalEmail = useRef(null);
  const modalWsp = useRef(null);

  //DETALLE
  const [data, setData] = useState(body?.status ? body.detalle : []);

  //STADISTICS
  const stadicts = (() => {
    const IGV_RATE = 0.18;

    // Calcular afecto en base imponible (sin IGV)
    const impAfecto = data.reduce(
      (acc, item) => (item.igv === "S" ? acc + item.importe / (1 + IGV_RATE) : acc),
      0
    );

    const impInafecto = data.reduce(
      (acc, item) => (item.igv === "N" ? acc + item.importe : acc),
      0
    );

    const dsctTasa = Number(descuento) || 0;

    // Descuento solo sobre lo afecto
    const dsctImp = impAfecto * (dsctTasa / 100);

    const baseNeta = impAfecto - dsctImp;
    const igv = baseNeta * IGV_RATE;

    return {
      subtotal: baseNeta + impInafecto, // sin IGV
      igv,
      total: baseNeta + impInafecto + igv,
      descuento: dsctImp,
    };
  })();

  //FORMULARIO MAESTRO
  const form1 = useForm({
    defaultValues: {
      tipComprobante: "CO",
      serComprobante: "",
      fecOperacion: new Date().toLocaleDateString('en-CA', { timeZone: 'America/Lima' }),
      fecVencimiento: (body?.status) ? body.venta?.fVencimiento?.split("T")[0] ?? ""  : "",
      idMoneda: "1",
      impAfecto: 0.0,
      impInafecto: 0.0,
      _base: 0,
      igv: 18.0,
      impTotal: 0.0,
      dsctTasa01: 0.0,
      dsctTasa02: 0.0,
      dsctImp01: 0.0,
      dsctImp02: 0.0,
      impDsctoTotal: 0.0,
      idcont: "",
      idTPago: "",
      numItems: 0,
      idUsuario: user?.idUsuario || "",
      idMedioPago: "",
      impuesto: 0,
      tcambio: 0,
      obs: (body?.status) ? body.venta.tipo ?? "PROFORMA" : "PROFORMA",
      atte: "",
      tiempoEntrega: (body?.status) ? body.venta.tiempoEntrega ?? "" : "",
      garantia:  (body?.status) ? body.venta.condiciones ?? "" : "",
    },
  });

  const form2 = useForm({
    defaultValues: {
      email: "",
    },
  });

  const form3 = useForm({
    defaultValues: {
      numero: "",
      indice: "51",
    },
  });

  const setValueTable = (row) => {
    setValueTableDefault(row, setData)
  };

  const columns = [
    {
      header: (
        <th
          className="sort white-space-nowrap align-middle"
          scope="col"
          style={{ minWidth: "200px" }}
        >
          PRODUCTO / SERVICIO
        </th>
      ),
      accessorKey: "nombreAlternativo",
      cell: ({ row }) => (
        <EditableCellTextarea
          value={row.original.nombreAlternativo}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="nombreAlternativo"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "150px" }}
        >
          CANTIDAD
        </th>
      ),
      accessorKey: "cantidad",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.cantidad}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="cantidad"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle"
          scope="col"
          style={{ width: "300px" }}
        >
          PRECIO U.
        </th>
      ),
      accessorKey: "precio",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.precio}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="precio"
          clase={""}
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          DESCUENTO
        </th>
      ),
      accessorKey: "dscto01",
      cell: ({ row }) => (
        <EditableCellNumber
          value={row.original.dscto01}
          setValueTable={setValueTable}
          rowIndex={row.index}
          columnKey="dscto01"
          clase="badge badge-phoenix fs-10 badge-phoenix-info rounded-4"
        />
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "150px" }}
        >
          SUB TOTAL
        </th>
      ),
      accessorKey: "subtotal",
      cell: ({ row }) => (
        <td className="color align-middle white-space-nowrap text-body py-0 text-end">
          {parseFloat(row.original.subtotal).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "250px" }}
        >
          TOTAL
        </th>
      ),
      accessorKey: "importe",
      cell: ({ row }) => (
        <td className="total align-middle fw-bold text-body-highlight text-end py-0">
          {parseFloat(row.original.importe).toFixed(2)}
        </td>
      ),
    },
    {
      header: (
        <th
          className="sort align-middle text-end"
          scope="col"
          style={{ width: "10px" }}
        ></th>
      ),
      accessorKey: "acciones",
      cell: ({ row }) => {
        const igvColor =
          row.original.igv === "S" ? "text-primary" : "text-secondary";
        return (
          <td className="total align-middle fw-bold text-body-highlight text-end py-1">
            <div className="row justify-content-end g-0">
              <div
                className="col-auto"
                onClick={() => {
                  deleteProduct(row.index);
                }}
              >
                <span
                  className="text-danger uil-trash-alt"
                  title="Eliminar"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
              <div
                className="col-auto"
                onClick={() => {
                  deleteIGV(row.index);
                }}
              >
                <span
                  className={`${igvColor} uil-file-upload-alt`}
                  title="IGV"
                  style={{ fontSize: "15px", cursor: "pointer" }}
                ></span>
              </div>
            </div>
          </td>
        );
      },
    },
  ];

  const deleteIGV = (rowIndex) => {
    deleteIGVDefault(rowIndex, setData);
  };

  const deleteProduct = (index) => {
    deleteProductDefault(index, setData);
  };

  useEffect(() => {
    const axiosProducts = async () => {
      const response = await petitions.getProductsType(
        idEmpresa(),
        session().token,
        type
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.idProducto,
          label: e.nombre,
          pventa: e.pVenta,
          stock: e.stock,
        }));
        setPservicio(array);
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    axiosProducts();
  }, [idEmpresa, session, type]);

  useEffect(() => {
    const fetchSeries = async () => {
      const obj = session();
      const response = await petitions.getSeries(idEmpresa(), obj.token);

      if (response.status === "success") {
        const data = response.data;

        // 🔎 solo trabajamos con las series habilitadas
        const habilitadas = data.filter((s) => s.estado === "S");

        setSeries(habilitadas);

        // --- lógica de selección automática ---
        if (habilitadas.length === 0) {
          setSerComprobante("");
          return;
        }

        const cotizaciones = habilitadas.filter((s) => s.tipComprobante === "CO");
        const cotizacionDefecto = cotizaciones.find((s) => s.defecto === "S");

        setSerComprobante(
            cotizacionDefecto
            ? cotizacionDefecto.serie
            : cotizaciones[0]?.serie || "",
        );
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchSeries();
  }, [idEmpresa, session]);


  useEffect(() => {
    const getMoneda = async () => {
      const response = await petitions.getMoneda(idEmpresa(), session().token);
      if (response.status === "success") {
        var array = response.data.map((e) => ({
          value: e.idMoneda.toString(),
          label: e.simbolo,
        }));
        setMoneda(array);

        form1.setValue("idMoneda", body?.status ? body?.venta.idMoneda.toString() ?? "1" : "1", {
          shouldValidate: false,
        })
        
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    getMoneda();
  }, [form1, session, idEmpresa, body?.status, body?.venta?.idMoneda]);

  useEffect(() => {
    const getMedPago = async () => {
      const response = await petitions.getMedPagos(
        idEmpresa(),
        session().token
      );
      if (response.status === "success") {
        var array = [];
        response.data.forEach((e) => {
          array.push({ value: e.idMedPago, label: e.descripcion });
        });
        seMpago(array);
        form1.setValue("idMedioPago", body?.status ? body?.venta.idMedioPago ?? "" : "", {
          shouldValidate: false,
        })
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };
    getMedPago();
  }, [body?.status, body?.venta.idMedioPago, form1, idEmpresa, session]);

  useEffect(() => {
    const fetchTPago = async () => {
      const response = await petitions.getTPago(idEmpresa(), session().token);
      if (response.status === "success") {
        var array = [];
        response.data.forEach((e) => {
          if (e.estado === "S") {
            array.push({ value: e.idTpago, label: e.descripcion });
          }
        });
        setTpago(array);
        form1.setValue("idTPago", body?.status ? body?.venta.idTipoPago ?? "": "", {
          shouldValidate: false,
        })
      } else {
        const msg =
          typeof response.code === "string" ? response.message : response.data;
        toast.error(msg);
      }
    };

    fetchTPago();
  }, [body?.status, body?.venta.idTipoPago, form1, idEmpresa, session]);

  useEffect(() => {
    const fetchClientes = async () => {
      const obj = session();
      const response = await petitions.getClientesSelect(
        idEmpresa(),
        obj.token
      );
      if (response.status === "success") {
        const array = response.data.map((e) => ({
          value: e.id,
          label: e.descripcion,
        }));
        setClientes(array);
        form1.setValue("idcont", body?.status ? (body?.venta.idcont ?? "") : "", {
          shouldValidate: false,
        });
      } else {
        const msg =
          typeof response.code === "string"
            ? response.message
            : response.data;
        toast.error(msg);
      }
    };

    fetchClientes();
  }, [body?.status, body?.venta.idcont, form1, idEmpresa, session]);

  const sendCotizacion = form1.handleSubmit(async (form) => {
    if (serComprobante === "") {
      toast.warning("Debe seleccionar una serie para la cotización.")
      return;
    }

    form.serComprobante = serComprobante
    const maestro = calculateAmountsVenta(form, data, descuento);

    var join = {
      cotizacion: maestro,
      detalleVenta: data,
    };

    toast("¿Estas seguro(a) de registrar esta cotización?", {
      action: {
        label: "Confirmar",
        onClick: async () => {
          const response = await petitions.insertCotizacion(
            idEmpresa(),
            session().token,
            join
          );
          if (response.status === "success") {
            setIdVenta(response.data.idVenta);
            comp.current =
              response.data.tipComprobante +
              "-" +
              response.data.serComprobante +
              "-" +
              response.data.numComprobante;
            monto.current = response.data.impTotal;
            money.current = moneda.find(
              (m) => m.value === form.idMoneda
            )?.label;
            const modal = new window.bootstrap.Modal(modalConfirmacion.current);
            modal.show();
            form1.reset();
            setData([]);
          } else {
            var msg =
              typeof response.code === "string"
                ? response.message
                : response.data;
            toast.error(msg);
          }
        },
      },
    });
  });

  const getReportVenta = async () => {
    const response = await petitions.getReportVenta(
      idEmpresa(),
      session().token,
      idVenta
    );

    if (response.isError) {
      toast.error(response.data || "No se pudo obtener el reporte");
      return;
    }

    const blob = new Blob([response.blob], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${comp.current}.pdf`;
    a.click();
    URL.revokeObjectURL(url);
  };

    
  const abrirModalEmail = () => {
    form2.reset();
    const modal = new window.bootstrap.Modal(modalEmail.current); 
    modal.show();
  };

  const abrirModalWsp = () => {
    form3.reset();
    const modal = new window.bootstrap.Modal(modalWsp.current);
    modal.show();
  }

  const sendEmail = form2.handleSubmit(async (data) => {
    const promise = petitions.sendEmailVenta(
      idEmpresa(),
      session().token,
      idVenta,
      data.email
    );

    toast.promise(promise, {
      loading: 'Enviando email...',
      success: (response) => {
        if (response.status === "success") {
          const modalInstance = window.bootstrap.Modal.getInstance(modalEmail.current);
          modalInstance.hide();
          return "Email enviado correctamente";
        } else {
          throw new Error(response.message || response.data || "Error desconocido");
        }
      },
      error: (err) => {
        if (err?.status === "error") {
          return err.message || err.data || "Error al enviar el email";
        }
        return "Error... :( Intenta de nuevo!";
      }
    });
  });

  const sendWsp = form3.handleSubmit(async (data) => {
    const response = await petitions.getReportVenta(
      idEmpresa(),
      session().token,
      idVenta
    );

    if (response.isError) {
      toast.error(response.message || "No se pudo obtener el reporte");
      return;
    }

    const fileURL = window.URL.createObjectURL(response.blob);

    var url = `https://wa.me/${data.indice}${data.numero}?text=${"Buenas tardes, adjunto el comprobante electronico: " + fileURL}`;
    window.open(url, '_blank'); 

    const modalInstance = window.bootstrap.Modal.getInstance(modalWsp.current);
    modalInstance.hide();
    toast.success("Mensaje enviado por WhatsApp");
  })

  return (
    <>
      <div className="row justify-content-between align-items-end g-3 mb-4">
        <div className="col-12 col-sm-auto col-xl-8">
          <h2 className="mb-0">Nueva cotización</h2>
        </div>
        <div className="col-12 col-sm-auto col-xl-4">
          <div className="d-flex">
            <button
              className="btn px-3 btn-phoenix-secondary px-3 me-2 rounded-4"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#filterModal"
              data-boundary="window"
              aria-haspopup="true"
              aria-expanded="false"
              data-bs-reference="parent"
              onClick={() => {
                const modal = new window.bootstrap.Modal(
                  modalConfiguracion.current
                );
                modal.show();
              }}
            >
              <span
                className="fas fa-cog text-primary"
                data-fa-transform="down-3"
              ></span>
            </button>
            <button className="btn btn-phoenix-primary px-5 me-2 rounded-4" onClick={()=>{
              form1.reset()
              setData([])
              setDescuento("")
            }}>
              Cancelar
            </button>
            <form onSubmit={sendCotizacion}>
              <button
                className="btn btn-primary px-5 w-100 text-nowrap rounded-4"
                href="event-detail.html"
                disabled={data.length === 0}
              >
                Guardar
              </button>
            </form>
          </div>
        </div>
      </div>

      <div className="row g-5">
        <div className="col-xl-8">
          <div className="row gx-3 gy-4 mb-4">
            <div className="row g-2">
              <div className="col-md-2">
                <div className="d-flex">
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "P" ? "active" : ""
                    }`}
                    title="Producto"
                    onClick={() => {
                      setProducto(null);
                      setType("P");
                    }}
                  >
                    {" "}
                    <span className="fas fa-book"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg me-1 rounded-3 ${
                      type === "S" ? "active" : ""
                    }`}
                    title="Servicio"
                    onClick={() => {
                      setProducto(null);
                      setType("S");
                    }}
                  >
                    {" "}
                    <span className="fas fa-wrench"></span>{" "}
                  </button>
                  <button
                    type="button"
                    className={`btn btn-phoenix-info btn-icon btn-icon-lg rounded-3 ${
                      type === "Q" ? "active" : ""
                    }`}
                    title="Paquete"
                    onClick={() => {
                      setProducto(null);
                      setType("Q");
                    }}
                  >
                    <span className="fas fa-box-open"></span>{" "}
                  </button>
                </div>
              </div>
              <div className="col-md-5">
                <Select
                  className="mb-0 mi-select"
                  classNamePrefix="rs"
                  options={pservicio}
                  value={producto}
                  styles={customStyles_v2}
                  placeholder={
                    type === "P"
                      ? "Buscar Producto"
                      : type === "S"
                      ? "Buscar Servicio"
                      : type === "Q"
                      ? "Buscar Paquete"
                      : "Buscar..."
                  }
                  isLoading={false}
                  isClearable={true}
                  onChange={(event) => {
                    if (!event) {
                      setProducto(null);
                      setCantidad(0);
                      setPrecio(0);
                    } else {
                      setProducto(event);
                      setCantidad(1);
                      setPrecio(event.pventa);
                    }
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-email"
                  id="add-property-wizardwizard-email"
                  placeholder="Cantidad"
                  value={cantidad}
                  onChange={(event) => {
                    setCantidad(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-2">
                <input
                  className="form-control input-spin-none rounded-4 border-0 shadow-sm"
                  type="number"
                  name="add-property-wizard-phone"
                  id="add-property-wizardwizard-phone"
                  placeholder="Precio"
                  value={precio}
                  onChange={(event) => {
                    setPrecio(event.target.value);
                  }}
                />
              </div>
              <div className="col-md-1">
                <button
                  className="btn btn-phoenix-secondary px-3 me-2 rounded-4"
                  type="button"
                  data-boundary="window"
                  aria-haspopup="true"
                  aria-expanded="false"
                  data-bs-reference="parent"
                  disabled={!producto || Object.keys(producto).length === 0}
                  onClick={() => {
                    if (empresa.validarAlmacen === "S" && producto.stock <= 0) {
                      toast.warning(
                        "No hay stock disponible para " + producto.label
                      );
                      return;
                    }
                    if (
                      empresa.validarAlmacen === "S" &&
                      producto.stock < cantidad
                    ) {
                      toast.warning(
                        "Cantidad supera el stock disponible (" +
                          producto.stock +
                          ")"
                      );
                      return;
                    }
                    if (empresa.validarAlmacen === "S" && cantidad <= 0) {
                      toast.warning("La cantidad debe ser mayor a 0");
                      return;
                    }
                    addProduct(producto, cantidad, precio, igv, setData, setProducto, setCantidad, setPrecio, user?.idUsuario);
                  }}
                >
                  <span
                    className="fas fa-plus text-success"
                    data-fa-transform="down-2"
                  ></span>
                </button>
              </div>
            </div>
          </div>

          <div className="row g-5 gy-7">
            <div className="col-12 col-xl-12 col-xxl-12">
              <div
                id="orderTable"
                data-list='{"valueNames":["products","color","size","price","quantity","total"],"page":10}'
                className="mb-3"
              >
                <div className="table-responsive scrollbar">
                  <Table data={data} columns={columns} />
                </div>
              </div>
              {data.length > 0 ? (
                <>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <span className="badge badge-phoenix fs-10 badge-phoenix-secondary mt-1 mb-2 me-4 rounded-3 border-0 shadow-sm">
                      <span className="far fa-lightbulb me-1"></span>  El descuento afecta solo a operaciones gravadas
                    </span>
                    <p className="text-body-emphasis  lh-sm mb-0 me-5 mt-1">
                      Descuentos (%)
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2 mt-1">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <input
                      type="number"
                      className="form-control form-control-sm text-star rounded-4 border-0 shadow-sm"
                      placeholder="Descuento"
                      style={{ minWidth: "130px", maxWidth: "120px" }}
                      value={!data.some(item => item.igv === "S") ? 0 : descuento}
                      onChange={(e) => setDescuento(e.target.value)}
                      disabled={!data.some(item => item.igv === "S")}
                    />
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">
                      Subtotal
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.subtotal).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis  lh-sm mb-0 me-5">IGV</p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <p
                      className="text-body-emphasis fw-semibold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.igv).toFixed(2)}
                    </p>
                  </div>
                  <div className="d-flex justify-content-end py-1 border-translucent">
                    <p className="text-body-emphasis fw-semibold lh-sm mb-0 me-5">
                      Total
                    </p>
                    <p className="text-body-emphasis fw-bold lh-sm mb-0 me-2">
                      {
                        moneda.find(
                          (mon) => mon.value === form1.getValues("idMoneda")
                        )?.label
                      }
                    </p>
                    <p
                      className="text-body-emphasis fw-bold lh-sm mb-0 me-2"
                      style={{ minWidth: "120px" }}
                    >
                      {parseFloat(stadicts.total).toFixed(2)}
                    </p>
                  </div>
                </>
              ) : (
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ height: "300px" }}
                >
                   <img
                      className="d-dark-none mt-5 position-sticky"
                      src={productEmpty_light}
                  
                      alt="No hay productos"
                      style={{
                        maxWidth: "300px",
                        marginBottom: "10px",
                        opacity: "0.5",
                      }}
                    />
                    <img
                      className="d-light-none mt-5 position-sticky"
                      src={productEmpty_dark}
                      alt="No hay productos"
                      style={{
                        maxWidth: "300px",
                        marginBottom: "10px",
                        opacity: "0.5",
                      }}
                    />

                    <h5 className="text-muted mt-3" style={{opacity: "0.5"}}>No hay productos</h5>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="col-xl-4">
          <div className="border-translucent pb-6 mb-1">
            <div className="card mb-3 rounded-4 border-0 shadow-sm">
              <div className="card-body">
                <div className="row gx-3">
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="form-floating mb-3">
                      <input
                        className="form-control input-spin-none rounded-4"
                        id="floatingInput"
                        type="text"
                        {...form1.register("obs", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                      />
                      {form1.formState.errors?.obs && (
                        <code>{form1.formState.errors.obs.message}</code>
                      )}
                      <label htmlFor="floatingInput">Tipo</label>
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="mb-3">
                      <div className="d-flex flex-wrap mb-2">
                        <h5 className="mb-0 text-body-highlight me-2">
                          Cliente
                        </h5>
                        <NavLink
                          className="fw-bold fs-9"
                          to={"/main/NuevoCliente"}
                        >
                          Nuevo cliente
                        </NavLink>
                      </div>
                      <Select
                        className="mb-0 mi-select mi-select-bordered"
                        classNamePrefix="rs"
                        styles={customStyles}
                        placeholder="Selecciona un cliente"
                        options={clientes}
                        value={
                          clientes.find(
                            (option) => option.value === form1.watch("idcont")
                          ) || null
                        }
                        {...form1.register("idcont", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idcont", event.value);
                        }}
                      />
                      {form1.formState.errors?.idcont && (
                        <code>{form1.formState.errors.idcont.message}</code>
                      )}
                    </div>
                  </div>
                  <hr />
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="mb-1">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Condiciones de pago
                      </label>
                      <input
                        className="form-control input-spin-none rounded-4"
                        id="exampleFormControlInput"
                        type="text"
                        {...form1.register("garantia", {
                          maxLength: {
                            value: 255,
                            message: "Máximo 255 caracteres",
                          },
                        })}
                      />
                      {form1.formState.errors?.garantia && (
                        <code>{form1.formState.errors.garantia.message}</code>
                      )}
                    </div>
                  </div>
                  <div className="col-12 col-sm-6 col-xl-12">
                    <div className="mb-1">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Tiempo de entrega
                      </label>
                      <input
                        className="form-control input-spin-none rounded-4"
                        id="exampleFormControlInput"
                        type="text"
                        {...form1.register("tiempoEntrega", {
                          maxLength: {
                            value: 255,
                            message: "Máximo 255 caracteres",
                          },
                        })}
                      />
                      {form1.formState.errors?.tiempoEntrega && (
                        <code>
                          {form1.formState.errors.tiempoEntrega.message}
                        </code>
                      )}
                    </div>
                  </div>
                  <div className="col-7 col-sm-6 col-xl-7">
                    <div className="mb-2">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Fecha expiración
                      </label>
                      <input
                        className="form-control rounded-4"
                        id="datepicker"
                        type="date"
                        {...form1.register("fecVencimiento", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                      />
                      {form1.formState.errors?.fecVencimiento && (
                        <code>
                          {form1.formState.errors.fecVencimiento.message}
                        </code>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-5">
                    <div className="mb-2">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Moneda
                      </label>
                      <select
                        className="form-select rounded-4"
                        value={form1.watch("idMoneda")}
                        {...form1.register("idMoneda", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idMoneda", event.target.value, {
                            shouldValidate: true,
                          });
                        }}
                      >
                        {moneda.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="mb-2">
                      <label
                        className="form-label"
                        htmlFor="exampleFormControlInput"
                      >
                        Tipo de pago{" "}
                      </label>
                      <Select
                        className="mb-1 mi-select mi-select-bordered"
                        classNamePrefix="rs"
                        styles={customStyles}
                        placeholder="Seleccionar"
                        options={tpago}
                        value={
                          tpago.find(
                            (option) => option.value === form1.watch("idTPago")
                          ) || null
                        }
                        {...form1.register("idTPago", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idTPago", event.value, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {form1.formState.errors?.idTPago && (
                        <code>{form1.formState.errors.idTPago.message}</code>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-6 mb-2">
                    <div className="mb-2">
                      <label
                        className="form-label rounded-4"
                        htmlFor="exampleFormControlInput"
                      >
                        Medio de pago{" "}
                      </label>
                      <Select
                        className="mb-1 mi-select mi-select-bordered"
                        classNamePrefix="rs"
                        placeholder="Seleccionar"
                        styles={customStyles}
                        options={mPago}
                        value={
                          mPago.find(
                            (option) =>
                              option.value === form1.watch("idMedioPago")
                          ) || null
                        }
                        {...form1.register("idMedioPago", {
                          required: {
                            value: true,
                            message: "Este campo es obligatorio",
                          },
                        })}
                        onChange={(event) => {
                          form1.setValue("idMedioPago", event.value, {
                            shouldValidate: true,
                          });
                        }}
                      />
                      {form1.formState.errors?.idMedioPago && (
                        <code>
                          {form1.formState.errors.idMedioPago.message}
                        </code>
                      )}
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-between border-top border-translucent border-dashed pt-4">
                  <h4 className="mb-0">Total :</h4>
                  <h4 className="mb-0">
                    {
                      moneda.find(
                        (mon) => mon.value === form1.getValues("idMoneda")
                      )?.label
                    }{" "}
                    {" " + parseFloat(stadicts.total).toFixed(2)}
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="staticBackdrop"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="false"
        ref={modalConfiguracion}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <div className="modal-header border-0">
              <h3 className="modal-title " id="documentModalLabel">
                Configuración de cotizaciones
              </h3>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <h5 className="mb-3">Opciones generales</h5>

              <div className="p-3 border rounded-4">
                <div className="form-check form-switch">
                  <input
                    className="form-check-input"
                    id="flexSwitchCheckChecked"
                    type="checkbox"
                    checked={igv}
                    onChange={() => {
                      setIgv(!igv);
                    }}
                  />
                  <label
                    className="form-check-label"
                    htmlFor="flexSwitchCheckChecked"
                  >
                    Impuesto General a las Ventas (IGV)
                  </label>
                </div>
                <div className="row mt-3">
                  <div className="col-lg-3 mt-2">
                    <p className="fw-bold">Cotización</p>
                  </div>
                  <div className="col-lg-6">
                    <select
                      className="form-select rounded-4"
                      value={serComprobante}
                      onChange={(e) =>
                        setSerComprobante(e.target.value)
                      }
                    >
                      {series
                        .filter((s) => s.tipComprobante === "CO")
                        .map((s) => (
                          <option key={s.idSerie} value={s.serie}>
                            {s.serie}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div className="col-lg-3">
                    <div className="bg-primary-subtle rounded-4 d-flex justify-content-center align-items-center mt-1" style={{ height: "50%" }}>
                      <p className="fs-9 text-primary fw-bold  mt-3">Por defecto</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade" 
        id="staticBackdrop" 
        tabIndex="-1" 
        data-bs-backdrop="static" 
        aria-labelledby="staticBackdropLabel" 
        aria-hidden="true"
        ref={modalConfirmacion}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content rounded-4">
            <div className="modal-body">
              <div className="d-flex align-items-center py-2 mb-1" role="alert">
                <span className="fas fa-check-circle text-success fs-5"></span>
                <p className="mb-0 flex-1 text-center">
                  Cotización registrada correctamente
                </p>
                <button
                  className="btn-close"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                ></button>
              </div>

              <h6 className="fs-7 text-primary text-center mb-4">
                {comp.current}{" "}
                <span className="ms-2 text-secondary">
                  {money.current}
                  {monto.current}
                </span>
              </h6>

              <div className="d-flex justify-content-center">
                <button
                  className="btn btn-phoenix-danger me-1 text-nowrap px-2 px-sm-4 rounded-4 border-0 shadow-sm"
                  title="Ver previo pdf"
                  type="button"
                  onClick={()=>{getReportVenta()}}
                >
                  <span className="far fa-file-pdf"></span>
                </button>
                <button
                  className="btn btn-phoenix-info me-1 text-nowrap px-2 px-sm-4 rounded-4 border-0 shadow-sm"
                  type="button"
                  title="Enviar por correo"
                  onClick={()=>{abrirModalEmail()}}
                >
                  <span className="far fa-envelope"></span>
                </button>
                <button
                  className="btn btn-phoenix-success me-1 text-nowrap px-2 px-sm-4 rounded-4 border-0 shadow-sm"
                  title="Enviar por WhatsApp"
                  type="button"
                  onClick={()=>{abrirModalWsp()}}
                >
                  <span className="fab fa-whatsapp"></span>
                </button>
                <NavLink
                  className="btn btn-phoenix-success me-1 text-nowrap px-2 px-sm-4 d-inline-flex align-items-center rounded-4 border-0 shadow-sm"
                  title="Ir al listado de ventas"
                  type="button"
                  to={"/main/VerCotizacion"}
                  onClick={()=>{
                    const modalInstance = window.bootstrap.Modal.getInstance(modalConfirmacion.current);
                    modalInstance.hide();
                  }}
                >
                  <span className="fas fa-clipboard-list"></span>
                  <span className="ms-2 mt-1">Listado</span>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalEmail}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendEmail}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por correo electronico
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        @
                      </span>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Email"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form2.register("email", {
                          required: "El email es requerido",
                          pattern: {
                            value:
                              /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                            message: "Email no válido",
                          },
                        })}
                      />
                    </div>
                    {form2.formState.errors.email && (
                      <span className="text-danger">
                        {form2.formState.errors.email.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        className="modal fade"
        id="exampleModal"
        tabIndex="-1"
        aria-hidden="true"
        ref={modalWsp}
      >
        <div className="modal-dialog">
          <div className="modal-content rounded-4">
            <form onSubmit={sendWsp}>
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Enviar por WhatsApp
                </h5>
                <button
                  className="btn p-1"
                  type="button"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span className="fas fa-times fs-9"></span>
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="input-group mb-1">
                      <span className="input-group-text" id="basic-addon1">
                        +
                      </span>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="51"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form3.register("indice", {
                          required: "El número es requerido",
                        })}
                      /> 
                    </div>
                    {form3.formState.errors.indice && (
                      <span className="text-danger">
                        {form3.formState.errors.indice.message}
                      </span>
                    )}
                  </div>
                  <div className="col-lg-8">
                    <div className="input-group mb-1">
                      <input
                        className="form-control"
                        type="number"
                        placeholder="999 999 999"
                        aria-label="Username"
                        aria-describedby="basic-addon1"
                        {...form3.register("numero", {
                          required: "El número es requerido",
                          pattern: {
                            value: /^\+?[1-9]\d{1,14}$/,
                            message: "Número no válido",
                          },
                        })}
                      /> 
                    </div>
                    {form3.formState.errors.numero && (
                      <span className="text-danger">
                        {form3.formState.errors.numero.message}
                      </span>
                    )}
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button className="btn btn-primary rounded-4" type="submit">
                  Enviar
                </button>
                <button
                  className="btn btn-outline-primary rounded-4"
                  type="button"
                  data-bs-dismiss="modal"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
